module.exports = __webpack_public_path__ + "media/images/marker-icon-2273e3d8.png";